import { QuickWinsTabContent } from "./QuickWinsTabContent"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const IgnoredTabQuickWins = (props: TabComponentProps) => (
  <QuickWinsTabContent {...props} tab="ignored" />
)
IgnoredTabQuickWins.displayName = "IgnoredTabQuickWins"
